/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode } from 'react';

import Heading from '@atlaskit/heading';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';

import { Card } from './card';
import type { GroupData, IconCardData } from './types';

export const IconCardGroup = ({ data }: { data: GroupData<IconCardData>[] }): React.JSX.Element => {
	return (
		<Stack space="space.600">
			{data.map(({ title, cards }) => (
				<Grid key={title?.toString()}>
					{cards.map(({ title, description, href }) => (
						<Card key={href} href={href} borderColor="color.border">
							<Box padding="space.200">
								<Inline alignBlock="start" spread="space-between">
									<Stack space="space.050">
										<Heading as="h4" size="small">
											{title}
										</Heading>
										<Text>{description}</Text>
									</Stack>
									<Box paddingBlockStart="space.025">
										<ArrowRightIcon color="var(--ds-icon-subtle)" label="arrow right" />
									</Box>
								</Inline>
							</Box>
						</Card>
					))}
				</Grid>
			))}
		</Stack>
	);
};

const gridStyles = xcss({
	display: 'grid',
	gap: 'space.100',
	gridTemplateColumns: '1fr',
	'@media (min-width: 48rem)': {
		gridTemplateColumns: '1fr 1fr',
	},
	'@media (min-width: 64rem)': {
		gridTemplateColumns: '1fr 1fr 1fr',
	},
});

const Grid = ({ children }: { children: ReactNode }) => {
	return <Box xcss={gridStyles}>{children}</Box>;
};
